import { App } from "./app";
let store;
export function initializeStore(initialData) {
    const _store = store !== null && store !== void 0 ? store : new App();
    // if there is data call the root store hydration method
    if (initialData) {
        _store.hydrate(initialData);
    }
    // For server side rendering always create a new store
    if (typeof window === "undefined")
        return _store;
    // Create the store once in the client
    if (!store)
        store = _store;
    return _store;
}
